/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespAboutModule_item = {
    readonly isCustomizable: boolean | null;
    readonly attributes: {
        readonly customizable: ReadonlyArray<{
            readonly text: string | null;
        } | null> | null;
        readonly ringResizable: ReadonlyArray<{
            readonly value: string | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDescriptionAbout_item" | "PdpSharedDescriptionAdditionalOptions_item" | "PdpRespDetails_item">;
    readonly " $refType": "PdpRespAboutModule_item";
};
export type PdpRespAboutModule_item$data = PdpRespAboutModule_item;
export type PdpRespAboutModule_item$key = {
    readonly " $data"?: PdpRespAboutModule_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespAboutModule_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespAboutModule_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCustomizable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "customizable",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "ringResizable",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAbout_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptions_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetails_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '272c387d5e2120ba2fe1667b4bb0c652';
export default node;
